module.exports = __webpack_public_path__ + "img/Alma-Digital.de822a7d.png";